import React from 'react';
import MaterialBreadcrumbs from '@mui/material/Breadcrumbs';
import {styled} from '@mui/material/styles';
import type {BreadcrumbsProps as MaterialBreadcrumbsProps} from '@mui/material/Breadcrumbs';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material';
import ArrowBack from '@mui/icons-material/West';

export type BreadcrumbsProps = MaterialBreadcrumbsProps;

const StyledBreadcrumbs = styled(MaterialBreadcrumbs)(({theme}) => ({
    fontSize: theme.typography.button.fontSize,
    '& .MuiBreadcrumbs-li': {
        '& .MuiTypography-root': {
            fontSize: theme.typography.button.fontSize
        }
    }
}));

const StyledArrowBack = styled(ArrowBack)(({theme}) => ({
    marginLeft: -theme.tokens.FuelSpacing1,
    marginRight: theme.tokens.FuelSpacing1,
    color: theme.tokens.FuelColorBrandPrimary
}));

const MobileBreadCrumbContainer = styled('span')(() => ({
    alignItems: 'center',
    display: 'inline-flex'
}));

export const Breadcrumbs = React.forwardRef<any, BreadcrumbsProps>(({
    children,
    ...props
}, ref) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const lastCrumb = React.Children.toArray(children).pop();

    return (
        <StyledBreadcrumbs
            aria-label={'Breadcrumbs'}
            ref={ref}
            {...props}
        >
            {isMobile ? (
                <MobileBreadCrumbContainer>
                    <StyledArrowBack/>
                    {lastCrumb}
                </MobileBreadCrumbContainer>
            ) : children}
        </StyledBreadcrumbs>
    );
});

Breadcrumbs.displayName = 'Breadcrumbs';
